import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import { fetchCommunitycitylist } from "../services/CommunityCity";
import { API_BASE } from "../api/apiConfig";

const CommunityDtl = () => {
  const { id } = useParams();

  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      try {
        const res = await fetchCommunitycitylist(decodeURIComponent(id));

        if (res?.data) {
          setCities(res.data);
        }
      } catch (err) {
        console.error("API ERROR:", err);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [id]);

  if (loading) {
    return <p className="text-center py-10">Loading...</p>;
  }

  if (!cities.length) {
    return <p className="text-center py-10">No Data Found</p>;
  }

  return (
    <>
      <Header />

      <main className="flex-1">
    {/*$*/}
    <main className="min-h-screen bg-gray-50">
      <section className="relative overflow-hidden bg-gradient-to-r from-primary/10 via-primary/5 to-primary/10 py-8 md:py-16">
        <div className="md:hidden absolute top-4 left-4 z-20">
          <button className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 hover:text-accent-foreground h-9 rounded-md px-3 bg-white/20 backdrop-blur-sm text-slate-800 hover:bg-white/30">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-arrow-left h-4 w-4 mr-1"
            >
              <path d="m12 19-7-7 7-7" />
              <path d="M19 12H5" />
            </svg>
            Back
          </button>
        </div>
        <div className="absolute left-0 top-0 h-48 w-48 md:h-96 md:w-96 rounded-full bg-primary/10 blur-3xl animate-pulse" />
        <div
          className="absolute bottom-0 right-0 h-48 w-48 md:h-96 md:w-96 rounded-full bg-primary/5 blur-3xl animate-pulse"
          style={{ animationDelay: "1s" }}
        />
        <div className="container mx-auto px-4 sm:px-6 md:px-8 relative z-10">
          <div className="text-center max-w-4xl mx-auto pt-8 md:pt-0">
            <div className="mb-4 md:mb-6 inline-flex items-center rounded-full border border-primary/30 bg-primary/10 px-4 py-2 md:px-6 md:py-3 text-sm md:text-base font-medium text-primary shadow-sm">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-map-pin mr-2 h-4 w-4 md:h-5 md:w-5 animate-pulse"
              >
                <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                <circle cx={12} cy={10} r={3} />
              </svg>
              Explore India City by City
            </div>
            <h1 className="mb-4 md:mb-6 text-2xl md:text-4xl lg:text-6xl font-bold tracking-tight text-slate-800 leading-tight">
              Discover Travel Communities{" "}
              <span className="text-primary">Across India</span>
            </h1>
            <p className="text-base md:text-xl lg:text-2xl text-slate-600 leading-relaxed max-w-3xl mx-auto">
              Join thousands of travelers in your city. From local meetups to
              group adventures, find your travel tribe and explore India
              together.
            </p>
          </div>
        </div>
      </section>
      <section className="py-8 md:py-16">
        <div className="container mx-auto px-4 sm:px-6 md:px-8">
          <ul className="ul-div grid gap-4 md:gap-8 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
        
        {cities.map((state) => state.city.map((city) => ( 
            <li
              className="text-card-foreground group overflow-hidden rounded-2xl border-0 md:border-2 md:border-slate-200 bg-white shadow-md md:shadow-lg transition-all duration-500 hover:border-primary/30 hover:shadow-2xl hover:-translate-y-1 md:hover:-translate-y-2"
              style={{ transitionDelay: "0ms" }}
            >
              <a className="block h-full" href={`/CommunityDtl/${city.id}`}>
                <div className="relative h-32 md:h-48 w-full overflow-hidden">
                  <img
                    alt={city.city}
                    loading="lazy"
                    decoding="async"
                    data-nimg="fill"
                    className="object-cover transition-transform duration-700 group-hover:scale-110"
                    style={{
                      position: "absolute",
                      height: "100%",
                      width: "100%",
                      left: 0,
                      top: 0,
                      right: 0,
                      bottom: 0,
                      color: "transparent"
                    }}
                    src={`${API_BASE}/${city.cover_image}`}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent" />
                  {/* <div className="inline-flex items-center rounded-full border transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent bg-primary hover:bg-primary/80 absolute right-3 md:right-4 top-3 md:top-4 border-none bg-gradient-to-r from-blue-500 to-blue-600 text-white text-xs md:text-sm font-semibold px-2 py-1 md:px-3 md:py-1.5 shadow-lg">
                    4x Monthly
                  </div>*/}
                  <div className="absolute bottom-3 md:bottom-4 left-3 md:left-4 right-3 md:right-4">
                    <div className="flex items-center gap-2 mb-1 md:mb-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-map-pin h-4 w-4 md:h-5 md:w-5 text-primary animate-bounce"
                      >
                        <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                        <circle cx={12} cy={10} r={3} />
                      </svg>
                      <span className="text-lg md:text-2xl font-bold text-white drop-shadow-lg">
                        {city.city}
                      </span>
                    </div>
                    {/*<div className="flex items-center gap-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-users h-3 w-3 md:h-4 md:w-4 text-white/80"
                      >
                        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                        <circle cx={9} cy={7} r={4} />
                        <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                      </svg>
                      <span className="text-sm md:text-base text-white/90 font-medium">
                        1240 travelers
                      </span>
                    </div> */}
                  </div>
                </div>
                <div className="p-4 md:p-6">
                  <div className="mb-3 md:mb-4 flex items-center justify-between">
                    <div className="flex items-center gap-2 px-2 py-1 md:px-3 md:py-1.5 rounded-full bg-gradient-to-r from-blue-50 to-blue-100">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-users h-3 w-3 md:h-4 md:w-4 text-slate-600"
                      >
                        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                        <circle cx={9} cy={7} r={4} />
                        <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                      </svg>
                      <span className="text-xs md:text-sm font-semibold text-slate-700">
                        {city.community_count}{/* */} members
                      </span>
                    </div>
                    <div className="flex items-center gap-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-star h-3 w-3 md:h-4 md:w-4 fill-amber-400 text-amber-400"
                      >
                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                      </svg>
                      <span className="text-xs md:text-sm font-semibold text-slate-700">
                        4.8
                      </span>
                    </div>
                  </div>
                  <p className="text-sm md:text-base text-slate-600 mb-3 md:mb-4 leading-relaxed">
                    {city.title}
                  </p>
                  {/*<div className="mb-3 md:mb-4">
                    <p className="text-xs md:text-sm font-semibold text-slate-800 mb-2">
                      Popular Attractions:
                    </p>
                    <div className="flex flex-wrap gap-1 md:gap-2">
                      <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 text-xs border-primary/30 text-primary bg-primary/5">
                        Marine Drive
                      </div>
                      <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 text-xs border-primary/30 text-primary bg-primary/5">
                        Bollywood Tours
                      </div>
                      <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 text-xs border-primary/30 text-primary bg-primary/5">
                        Street Food
                      </div>
                      <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 text-xs border-slate-300 text-slate-600">
                        +1 more
                      </div>
                    </div>
                  </div>*/}
                  <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md font-medium ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary hover:bg-primary/90 h-10 px-4 w-full bg-gradient-to-r from-blue-500 to-blue-600 text-white hover:opacity-90 transition-all duration-300 group-hover:scale-105 text-sm md:text-base py-2 md:py-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-calendar mr-2 h-3 w-3 md:h-4 md:w-4"
                    >
                      <rect width={18} height={18} x={3} y={4} rx={2} ry={2} />
                      <line x1={16} x2={16} y1={2} y2={6} />
                      <line x1={8} x2={8} y1={2} y2={6} />
                      <line x1={3} x2={21} y1={10} y2={10} />
                    </svg>
                    Join {/* */}{city.city}{/* */} Community
                  </button>
                </div>
              </a>
            </li>
          ))
          )}


          </ul>
          <div className="mt-12 md:mt-16 text-center">
            <div className="max-w-2xl mx-auto">
              <h3 className="text-xl md:text-2xl lg:text-3xl font-bold text-slate-800 mb-3 md:mb-4">
                Don't See Your City?
              </h3>
              <p className="text-sm md:text-lg text-slate-600 mb-4 md:mb-6">
                We're expanding to new cities every month. Join our waitlist to
                be notified when we launch in your area.
              </p>
              <button className="inline-flex items-center justify-center whitespace-nowrap font-medium ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 bg-primary text-white hover:bg-primary/90 transition-all duration-300 hover:scale-105 text-sm md:text-lg px-6 py-2 md:px-8 md:py-3 rounded-xl">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-trending-up mr-2 h-4 w-4 md:h-5 md:w-5"
                >
                  <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" />
                  <polyline points="16 7 22 7 22 13" />
                </svg>
                Request Your City
              </button>
            </div>
          </div>
        </div>
      </section>
    </main>
    {/*/$*/}
  </main>

  <Footer />

    </>
  );
};

export default CommunityDtl;
